export default `#version 300 es
precision highp float;
#define GLSLIFY 1

float luma(vec3 color) {
  return dot(color, vec3(0.299, 0.587, 0.114));
}

float luma(vec4 color) {
  return dot(color.rgb, vec3(0.299, 0.587, 0.114));
}

float triangle(float x) {
    return abs(fract(x) * 2.0 - 1.0);
}

in vec2 vUv;
in float vFragDepth;
flat in float vInstanceIndex;
flat in float vT;

out vec4 fragData[2];

uniform sampler2D tMap;
uniform vec3 uColor;
uniform float uEmissive;
uniform float uAlpha;
uniform float uTime;
uniform vec3 ambient;
uniform float uCameraScale;

#define animSpeed 0.02f

void main() {
    vec3 value = texture(tMap, vUv).rgb;
    float l = max(0.f, luma(value) - 0.1f);
    float alpha = uAlpha * l * (1.f - triangle(vT));

    if(alpha < 1.f / 255.f)
        discard;

    vec4 color = vec4(uColor, alpha);

    fragData[0] = color;
    gl_FragDepth = log2(vFragDepth) / uCameraScale;
}`